/*
 * @Author: etong
 * @Date: 2021-11-23 16:30:33
 * @LastEditTime: 2025-08-26 20:17:32
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @Description:
 * @FilePath: \oak\src\store\modules\routerMap\views\system.js
 * Think first, Program later
 */

// 系统设置
const map = {
  warehouseMasterData: () => import('@/views/system/WarehouseMasterData'),
  warehouseMasterDataDetail: () => import('@/views/system/WarehouseMasterData/Detail'), // 仓库管理主数据详情
  taxRate: () => import('@/views/system/TaxRate'),
  blackAndWhiteList: () => import('@/views/system/BlackAndWhiteList'),
  systemMonitoring: () => import('@/views/system/SystemMonitoring'),
  pageComponent: () => import('@/views/system/PageComponent'),
  roleList: () => import('@/views/system/RoleList'),
  roleDetail: () => import('@/views/system/RoleDetail'),
  userList: () => import('@/views/system/UserList'),
  userDetail: () => import('@/views/system/UserDetail'),
  addUser: () => import('@/views/system/components/User'), // 添加用户
  userPermission: () => import('@/views/system/components/User'), // 用户权限
  rolePermissionForm: () => import('@/views/system/rolePermission'), // 角色权限
  editNewUser: () => import('@/views/system/components/User'), // 编辑新增用户申请
  myRoleList: () => import('@/views/system/MyRoleList'),
  shopManage: () => import('@/views/system/shopManage'),
  shopManagementMasterData: () => import('@/views/system/ShopManagementMasterData'), // 店铺主数据，店铺管理
  shopManagementMasterDataDetail: () => import('@/views/system/ShopManagementMasterData/Detail'), // 店铺主数据详情
  invoice: () => import('@/views/system/Invoice'),
  financeCode: () => import('@/views/system/FinanceCode'),
  productLadderConfiguration: () => import('@/views/system/productLadderConfiguration'), // 商品阶梯配置
  methodReturns: () => import('@/views/system/MethodReturns'), // 方法返回字段配置
  uatAuthorityManage: () => import('@/views/system/UatAuthorityManage'), // uat用户权限
  customConfigurationPage: () =>
    import('@/views/system/CustomConfigurationPage'), // 自定义配置组件
  warning: () => import('@/views/system/Warning'), // 预警页面
  jjFlowTemplateList: () => import('@/views/system/jjFlowTemplateList'), // 审批流模板
  jjFlowConfig: () => import('@/views/system/jjFlowConfig'), // 审批流配置
  jjFlowConfigList: () => import('@/views/system/jjFlowConfigList'), // 审批流配置列表
  customQuery: () => import('@/views/system/CustomQuery'), // 自定义查询
  pageList: () => import('@/views/system/PageList'), // 页面列表
  createPage: () => import('@/views/system/CreatePage'), // 生成页面
  operationLogList: () => import('@/views/system/operationLogList'), // 系统操作日志
  visitRelationTables: () => import('@/views/system/VisitRelationTables'), // 数据库表结构详情
  projectList: () => import('@/views/system/ProjectList'), // 项目列表
  viewProjectListDetail: () => import('@/views/system/ProjectListDetail'), // 查看项目
  editProjectListDetail: () => import('@/views/system/ProjectListDetail'), // 编辑项目
  addProjectListDetail: () => import('@/views/system/ProjectListDetail'), // 新建项目
  projectTaskList: () => import('@/views/system/TaskList'), // 项目列表
  viewTaskListDetail: () => import('@/views/system/TaskListDetail'), // 查看项目
  editTaskListDetail: () => import('@/views/system/TaskListDetail'), // 编辑项目
  addTaskListDetail: () => import('@/views/system/TaskListDetail'), // 新建项目
  gantt: () => import('@/views/system/Gantt'), // 甘特图
  authorizationToDebug: () => import('@/views/system/AuthorizationToDebug'), // 授权调试列表页
  orderChangeWarehouseMark: () => import('@/views/system/orderChangeWarehouseMark'), // 订单转仓打标
  UserSystemPermissionsList: () => import('@/views/system/UserSystemPermissionsList'), // 人员系统权限
  IdsClientList: () => import('@/views/system/IdsClientList'), // 管理权限
  IdsClientDetail: () => import('@/views/system/IdsClientDetail'), // 管理权限
  skuFactoryRelationshipMasterData: () => import('@/views/system/SkuFactoryRelationshipMasterData'), // sku工厂关系
  skuFactoryRelationshipMasterDataDetail: () => import('@/views/system/SkuFactoryRelationshipMasterData/Detail'), // sku工厂关系主数据详情
  AmsWorkstationModuleList: () => import('@/views/system/AmsWorkstationModule/index'), // Ams工位模块列表
  AmsWorkstationModuleDetail: () => import('@/views/system/AmsWorkstationModule/Detail'), // Ams工位模块详情
  Seatmark: () => import('@/views/system/AmsWorkstationModule/Seatmark'), // 工位标记图
  smartApprovalRules: () => import('@/views/system/SmartApprovalRules') // 智能审批规则
}

export default map
